@if (filterEnable) {
<div class="row" style="border-top:1px solid #ccc; border-bottom:1px solid #ccc;padding:1em;margin-bottom:1em">
  <div class="col-12">
    <div class="button-container">
      Filtra per:
      @for (cat of listCatArt; track cat) {
      <dx-button stylingMode="contained" [id]="cat.id" [text]="getTitleButton(cat.id,cat.descrizione)"
        [type]="selectedCat === cat.id ? 'success' : 'normal'" width="120" (onClick)="filterByCategory(cat.id)">
      </dx-button>
      }
      <dx-button stylingMode="contained" id="0" [text]="getTitleButton(0,'Tutti')"
        [type]="selectedCat === 0 ? 'success' : 'normal'" width="120" (onClick)="filterByCategory(0)"></dx-button>
    </div>
  </div>
</div>
}

<dx-data-grid #gridArticoliConsegnati [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="false"
  [focusedRowIndex]="0" [columnAutoWidth]="true" [showColumnLines]="true" [showRowLines]="true"
  (onRowUpdating)="onUpdating($event)" [columnHidingEnabled]="false" (onInitNewRow)="onInitNewRow()"
  (onEditingStart)="onEditingStart()" (onRowPrepared)="onRowPrepared($event)"
  (onExporting)="onExporting($event)">
  <!-- <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-export [enabled]="true"></dxo-export>
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>

  <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false" [useIcons]="false">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>

  </dxo-editing>

  <!--<dxi-column *ngIf="bConsultazione" type="buttons" [width]="40" >
  <dxi-button
    hint="Assegna articolo"
    icon="plus"
    [visible]="bConsultazione"
  [onClick]="assegnaArticolo"></dxi-button>
</dxi-column>

-->



  <dxi-column [width]="25" cellTemplate="storicoColumn"></dxi-column>

  <div *dxTemplate="let d of 'storicoColumn'">
    <i class="dx-icon-detailslayout" style="color:#5c95cc; cursor: pointer;" (click)="apriPopUpStorico(d.data)"
      data-toggle="tooltip" data-placement="top" title="Storico consegne articolo"></i>
  </div>

  <dxi-column dataField="idDipendente" caption="Dipendente" [visible]="false" [visible]="idArticolo>0">
    <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" displayExpr="nominativo"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="idTipo" caption="Tipologia" width="300" [allowEditing]="bEditing" sortOrder="asc"
    [calculateSortValue]="sortByLookup" [visible]="idArticolo==0">
    <dxo-lookup [dataSource]="listTipiArticoliFiltrati" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="idArticolo" caption="Articoli" width="300" [allowEditing]="bEditing" sortOrder="asc"
    [calculateSortValue]="sortByLookup" [visible]="idArticolo==0">
    <dxo-lookup [dataSource]="getFilteredArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
    <dxi-validation-rule type="required" message="Selezionare l'articolo"></dxi-validation-rule>
  </dxi-column>




  <dxi-column dataField='idCategoria' caption="Categoria" [allowEditing]="false" [visible]="idArticolo==0">
    <dxo-lookup [dataSource]="listCatArt" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="countConsegne" caption="Num Consegne" dataType="number" width="80">
  </dxi-column>

  <dxi-column dataField="sumQta" caption="Qta" dataType="number" width="80">
  </dxi-column>

  <dxi-column dataField="matricola" caption="Matricola" width="80">
  </dxi-column>

  <dxi-column dataField="ultimaConsegna" caption="Data" format="dd/MM/yyyy" dataType="date" width="80">
  </dxi-column>

  <dxi-column dataField="dataScadenza" caption="Data Scadenza" format="dd/MM/yyyy" dataType="date" width="120">
  </dxi-column>

  <dxi-column dataField="previsto" caption="Previsto" dataType="boolean" width="80">
  </dxi-column>

</dx-data-grid>

@if (popUpVisible) {
<dx-popup title="Storico consenge" [showTitle]="true" [width]="900" [height]="500" [visible]="true"
  (onHiding)="onPopupCloseClick()">
  <app-grid-storico-consegne-articolo-dipendente [idDipendente]="idDipendenteRif"
    [idArticolo]="idArticoloRif"></app-grid-storico-consegne-articolo-dipendente>
</dx-popup>
}